import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ScreenLoaderContainer from '../../portal/controls/screenLoaderContainer';
import RolesGrid from './grid';
import { sort } from '../../../services/utils';
import styles from './style.scss';

@inject('translationsStore', 'rolesStore') @observer
export default class RolesGridContainer extends Component {

    rolesStore = this.props.rolesStore;
    permissionsStore = this.props.permissionsStore;

    componentDidMount() {

        this.props.rolesStore.getAllRoles();
    }

    render() {

        const roles = this.rolesStore.roles;

        let grid = null;

        if (roles === undefined) {

            grid = <ScreenLoaderContainer />;
        }
        else {
                        
            const sortedRoles = sort(roles)('name')('asc');

            grid = <RolesGrid
                        roles={sortedRoles}
                        translations={{
                            roles: this.props.translationsStore.translate('ROLES'),
                            description: this.props.translationsStore.translate('DESCRIPTION'),
                            noDataToDisplay: this.props.translationsStore.translate('NO_DATA_TO_DISPLAY'),
                            searchRoles: this.props.translationsStore.translate('SEARCH_ROLES'),
                            clear: this.props.translationsStore.translate('CLEAR'),
                            edit: this.props.translationsStore.translate('EDIT'),
                            delete: this.props.translationsStore.translate('DELETE'),
                            duplicate: this.props.translationsStore.translate('DUPLICATE'),
                            newRole: this.props.translationsStore.translate('NEW_ROLE'),
                            deleteRole: this.props.translationsStore.translate('DELETE_ROLE'),
                            deleteRoleConfirm: this.props.translationsStore.translate('DELETE_ROLE_CONFIRM'),
                            deleteButtonText: this.props.translationsStore.translate('DELETE'),
                            cancelText: this.props.translationsStore.translate('CANCEL'),
                            rolesDeletedSuccessMessage: this.props.translationsStore.translate('ROLE_DELETED_SUCCESS_MESSAGE'),
                            error: this.props.translationsStore.translate('ERROR'),
                            close: this.props.translationsStore.translate('CLOSE')
                        }}
                    />;
        }

        return(
            <div
                className={styles.rolesMainWrapper}
            >
                {grid}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/roles/rolesGrid/index.jsx